@let iconName = icon();
@let iconSizeArr = iconSize();

@if (loading()) {
    <h-loader-spinner />
}

@if (iconName) {
    <span class="button-icon">
        <h-svg-icon
            [name]="iconName"
            [height]="iconSizeArr?.[0]"
            [width]="iconSizeArr?.[1]"
            [fill]="iconDrawing() === DRAWING.FILL ? 'currentColor' : 'none'"
            [stroke]="iconDrawing() === DRAWING.STROKE ? 'currentColor' : 'none'" />
    </span>
}
<span class="button-label label-medium">
    <ng-content />
</span>
